import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import StateInfoField from "./StateInfoField";
import { format, parseISO } from "date-fns";
import ru from "date-fns/locale/ru";
import RolesBadges from "./RolesBadges";
import CardPersonBlock from "../../../../../ui/CardPersonBlock";
import RoleSymbol from "../../../../../ui/RoleSymbol";
import EditButton from "../../../../../ui/EditButton";
import KuratorEditModal from "./KuratorEditModal";

const calcToday = date =>
    date ? format(parseISO(date), "dd.MM.yy", { locale: ru }) : null;

const styles = () => ({
    root: {
        maxWidth: 774,
        minWidth: 400,
        display: "flex",
        flexDirection: "column",
        "& .MuiFormLabel-root": {
            whiteSpace: "nowrap"
        },
        "& .MuiInputBase-input.Mui-disabled": {
            color: "#000"
        }
    },
    heading: {
        fontSize: 14,
        display: "flex",
        alignItems: "center",
        color: "#000000",
        margin: "16px 0 16px 0"
    },
    profileInfo:{
      marginBottom: 16,
    },
    field: {
      width: 105,
      minWidth: 105,
      paddingRight: 16,
    },
    value: {
      fontSize: 12,
    }
});

const defaultData = {
  isProfileModalOpen: false
}

const ProfileInfo = ({ orgId, classes, profile, updateProfile }) => {
  const [data, setData] = React.useState(defaultData);
  const profileInfo = profile ? profile.info : null;

  const setObjectState = (name, value) => {
    const newState = {
      ...data,
      [name]: value
    };

    setData(newState);
  };

    return (
        <div className={classes.root}>
          {profileInfo &&
          <KuratorEditModal
            orgId={orgId}
            updateProfile={updateProfile}
            curatorId={profileInfo.curatorId}
            open={data.isProfileModalOpen}
            handleClose={() => setObjectState("isProfileModalOpen", false)}/>}
            <div className={classes.heading}>
              <Typography className={classes.heading} style={{marginRight: "16px"}}>
                Учетные данные
              </Typography>
              <EditButton onClick={() => setObjectState("isProfileModalOpen", true)}/>
            </div>

            <Typography className={classes.heading}>
              Куратор
            </Typography>
            {(profileInfo && profileInfo.curatorId && profileInfo.curatorId>-1) ?
            <CardPersonBlock image={profileInfo.curatorAvatar}
                              name={profileInfo.curatorName}
                              desc={profileInfo.curatorPost}
                            personId={profileInfo.curatorId}/>
            :<Typography
              className={classes.field}
              variant="caption"
              color="textSecondary">
              не выбран
            </Typography>}

            <Typography className={classes.heading}>
            Роли куратора в системе
            </Typography>
            {(profile.roles && profile.roles.length>0) ?
              <StateInfoField value={
                profile.roles.map(({ symbol, name }) =><RoleSymbol lg={true} symbol={symbol} title={name}/>)
              }
            />
            : <Typography
              className={classes.field}
              variant="caption"
              color="textSecondary">
              не указаны
            </Typography>
            }

            {profileInfo &&
              <>
            <Typography className={classes.heading}>Состояние учетной записи</Typography>
            <div className={classes.profileInfo}>
              <StateInfoField field="Состояние:" value={profileInfo.sysStateName || "-"}/>
              <StateInfoField field="Зарегистрирован:" value={profileInfo.sysRegDate ? calcToday(profileInfo.sysRegDate) : "-"}/>
              <StateInfoField field="Способ регистрации:" value={profileInfo.sysRegModeName || "-"}/>
              <StateInfoField field="Open Id:" value={profileInfo.sysOpenId || "-"}/>
            </div></>}
        </div>
    );
};
export default withStyles(styles)(ProfileInfo);
